import { twMergeExt } from '@/shared/utils/twMergeExt';
import { FC } from 'react';
import { cvaIcon, cvaNotAllowed, cvaRoot } from './AvailabilityStyles';
import IconNotAllowed from '/public/icons/notallowed.svg';

interface Props {
  value: number;
  className?: string;
}

const Availability: FC<Props> = ({ value = 8, className }) => {
  const availabilityCasesText = () => {
    switch (true) {
      case value === 0:
        return 'Нет в наличии';
      case value === 1:
        return 'Осталось мало';
      case value > 1 && value <= 3:
        return 'Осталось мало';
      case value > 1 && value < 5:
        return 'Осталось средне';
      case value >= 5:
        return 'Осталось много';
      default:
        return 'Нет в наличии';
    }
  };

  return (
    <div
      className={twMergeExt(
        cvaRoot({
          color: value >= 5 ? 'green' : value > 3 && value < 5 ? 'yellow' : value === 0 ? 'gray' : 'red',
        }),
        className
      )}
    >
      {value > 0 ? (
        <svg className={cvaIcon({})} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            x="6.86914"
            y="4.60547"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(135 6.86914 4.60547)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 1 ? 1 : 0.32}
          />
          <rect
            x="4.7998"
            y="6.40039"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(90 4.7998 6.40039)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 2 ? 1 : 0.32}
          />
          <rect
            x="4.60625"
            y="9.13096"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(45 4.60625 9.13096)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 3 ? 1 : 0.32}
          />
          <rect
            x="6.40039"
            y="11.2002"
            width="3.2"
            height="4.8"
            rx="1.6"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 4 ? 1 : 0.32}
          />
          <rect
            x="14.7871"
            y="12.5254"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(135 14.7871 12.5254)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 5 ? 1 : 0.32}
          />
          <rect
            x="16"
            y="6.40039"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(90 16 6.40039)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 6 ? 1 : 0.32}
          />
          <rect
            x="12.5254"
            y="1.21191"
            width="3.2"
            height="4.8"
            rx="1.6"
            transform="rotate(45 12.5254 1.21191)"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 7 ? 1 : 0.32}
          />
          <rect
            x="6.40039"
            width="3.2"
            height="4.8"
            rx="1.6"
            fill={value >= 5 ? '#3DC869' : value > 3 && value < 5 ? '#FFB016' : '#FF5E7F'}
            opacity={value >= 8 ? 1 : 0.32}
          />
        </svg>
      ) : (
        <IconNotAllowed className={cvaNotAllowed({})} />
      )}

      {availabilityCasesText()}
    </div>
  );
};

export default Availability;
